export default __webpack_public_path__ + "assets/png/6a2e2af86e791b49e3d34faecc2add0b.png";